import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { STACK_SCREENS } from "../config/NavigationConfig";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import HomeWebScreen from "../../screens/Auth/WebScreens/HomeWebScreen";
import ChatScreen from "../../screens/Auth/WebScreens/ChatScreen";

const Stack = createStackNavigator();

export const HomeTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen
      name="HomeScreen"
      component={withErrorBoundary(HomeWebScreen)}
      options={{ title: "Home" }}
    />
    {STACK_SCREENS.HOME.slice(1).map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);

export const ChatTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    {STACK_SCREENS.CHAT.map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);

export const MyEventsTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    {STACK_SCREENS.MY_EVENTS.map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);

export const HelpChatTabStack = ({ isAdmin }) => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {isAdmin ? (
        <Stack.Screen name={"chat"} component={ChatScreen} />
      ) : (
        <Stack.Screen name="HomeScreen" component={HomeWebScreen} />
      )}
      {STACK_SCREENS.HELP_CHAT.map((screen, index) => (
        <Stack.Screen
          key={index}
          name={screen.name}
          component={screen.component}
          options={screen.options}
        />
      ))}
    </Stack.Navigator>
  );
};

export const DisputeTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    {STACK_SCREENS.DISPUTE.map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);

export const ProfileTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    {STACK_SCREENS.PROFILE.map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);

export const PurchaseTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    {STACK_SCREENS.PURCHASE.map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);

export const HelpTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    {STACK_SCREENS.HELP.map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);

export const NotificationTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    {STACK_SCREENS.NOTIFICATION.map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);

export const SettingTabStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    {STACK_SCREENS.SETTING.map((screen, index) => (
      <Stack.Screen
        key={index}
        name={screen.name}
        component={screen.component}
        options={screen.options}
      />
    ))}
  </Stack.Navigator>
);